// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VCip","left":"styles_left__1i1eb","right":"styles_right__29LOu","alert":"styles_alert__CLQ3J"};